import React, { useState, useEffect } from 'react';

// ==========================================
// CONFIGURACIÓN DE DATOS DINÁMICOS Y CONFIGURABLE
// ==========================================
export const workshopConfig = {
    name: "TALLER PRESENCIAL DE PUBLICIDAD QUE VENDE",
    date: "Sábado 5 de diciembre de 2026",
    time: "1:00 p. m. a 6:00 p. m.",
    duration: "5 horas",
    city: "Medellín, Colombia",
    locationPending: "Medellín (Dirección exacta se comunicará a los inscritos por canales oficiales)",
    totalSlots: 20,
    currentSlotsSold: 3,
    currentPhase: {
        name: "PREVENTA 1",
        price: 179900,
        formattedPrice: "$179.900 COP",
        limit: 5,
    },
    stages: [
        { name: "PREVENTA 1", slots: "Sólo 5 cupos", price: "$179.900 COP", active: true },
        { name: "PREVENTA 2", slots: "Sólo 7 cupos", price: "$199.900 COP", active: false },
        { name: "PREVENTA 3", slots: "Últimos 8 cupos", price: "$229.900 COP", active: false },
    ],
    bonus: {
        title: "¿QUÉ LE RESPONDO?",
        description: "Asistente de ventas con inteligencia artificial que te ayuda a responder mejor a tus clientes, manejar objeciones como 'está muy caro' o 'lo voy a pensar' y encontrar la respuesta y el siguiente paso más adecuados para avanzar hacia el cierre de una venta.",
        value: "$69.900 COP mensuales",
        duration: "15 días de acceso GRATIS",
        remainingBonuses: 3,
    },
    instructor: {
        name: "Ing. Luis Eduardo Nieto",
        bio: "Instructor de este entrenamiento presencial de Dissemp Academy. Mi objetivo es ayudarte a comprender cómo funciona Meta Ads y enseñarte a estructurar tus propias campañas publicitarias mediante una metodología práctica y fácil de seguir.",
        photoUrl: "/assets/images/instructor-placeholder.jpg"
    },
    whatsappNumber: "573014953565",
    vslUrl: "https://www.youtube.com/embed/placeholder-vsl",
    checkoutUrl: "#pricing-section"
};

// ==========================================
// COMPONENTE PRINCIPAL DE LA LANDING PAGE
// ==========================================
export default function MetaAdsWorkshopLanding() {
    const [openFaq, setOpenFaq] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'PageView');
            window.fbq('track', 'ViewContent', {
                content_name: workshopConfig.name,
                content_category: 'Presencial Workshop',
                value: workshopConfig.currentPhase.price,
                currency: 'COP'
            });
        }
    }, []);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const handleInitiateCheckout = () => {
        if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'InitiateCheckout', {
                value: workshopConfig.currentPhase.price,
                currency: 'COP'
            });
        }
        const pricingEl = document.getElementById('pricing-section');
        if (pricingEl) {
            pricingEl.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [showWhatsAppFloat, setShowWhatsAppFloat] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowWhatsAppFloat(true);
            } else {
                setShowWhatsAppFloat(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const whatsappMessage = encodeURIComponent("¡Hola! Me quiero inscrbir en el Taller Presencial de Publicidad Digital en Medellín.");
    const whatsappUrl = `https://wa.me/${workshopConfig.whatsappNumber}?text=${whatsappMessage}`;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
    const [modalStep, setModalStep] = useState(1); // 1: Formulario datos, 2: Métodos de pago
    const [paymentMethod, setPaymentMethod] = useState('transfer'); // 'transfer' o 'card'
    const [copied, setCopied] = useState(false);

    const handleFormSubmit = (e) => {
        e.preventDefault();

        // Datos a enviar incluyendo el course_id estático y el status inicial
        const payload = {
            ...formData,
            course_id: 13,
            status: 'pending' // 'pending' para remarketing inicial
        };

        // 1. Ejecución asíncrona transparente (fetch al backend en PHP)
        fetch(`${process.env.REACT_APP_HOST_BACKEND}/interested/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).catch(err => console.error("Error en segundo plano:", err));

        // 2. Avanzar de inmediato al paso de métodos de pago sin bloquear al usuario
        setModalStep(2);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    // Función para manejar la finalización del pago por Transferencia
    const handleTransferSubmit = async (e) => {
        e.preventDefault();
        
        try {
            // 1. Armar el FormData con los datos del estudiante y el taller
            const formDataToSend = new FormData();
            formDataToSend.append('fullName', formData.name);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('phone', formData.phone);
            formDataToSend.append('country', 'CO'); // O el país correspondiente
            formDataToSend.append('course_id', 13); // ID del programa del taller
            formDataToSend.append('course_name', 'PUBLICIDAD QUE SI VENDE'); // Nombre del programa
            formDataToSend.append('course_type_title', 'Taller Presencial'); // Tipo del programa
            formDataToSend.append('currency', 'COP');
            formDataToSend.append('program_price', workshopConfig.currentPhase.price);
            formDataToSend.append('payment_status', 'pending'); // Queda pendiente hasta verificar el comprobante
            formDataToSend.append('payment_method', 'transfer');
            

            // Si agregaste un input file para el comprobante en la vista de transferencia:
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput && fileInput.files[0]) {
                formDataToSend.append('paymentProof', fileInput.files[0]);
            }

            // 2. Registrar al estudiante en la tabla students y students_program
            const apiUrlSaveStudent = `${process.env.REACT_APP_HOST_BACKEND}/students/insert`;
            const studentResponse = await fetch(apiUrlSaveStudent, {
                method: "POST",
                body: formDataToSend,
                mode: "cors"
            });

            if (studentResponse.status === 409) {
                alert("Ya este correo esta inscrito en este programa. Si tienes dudas, escríbenos por WhatsApp.");
                return;
            }

            if (!studentResponse.ok) {
                const errorData = await studentResponse.json().catch(() => null);
                throw new Error(errorData?.message || `Error del servidor (${studentResponse.status})`);
            }

            const result = await studentResponse.json();
            console.log("Respuesta backend:", result);

            const { payment_token } = result;
            formDataToSend.append("payment_token", payment_token);

            // 3. Enviar correo de inscripción nueva
            const apiUrlEmail = `${process.env.REACT_APP_HOST_BACKEND}/send_inscription_academy`;
            await fetch(apiUrlEmail, {
                method: "POST",
                body: formDataToSend,
                mode: 'cors'
            });

            // 4. Actualizar el estatus del interesado a 'enrolled' o 'registered'
            fetch(`${process.env.REACT_APP_HOST_BACKEND}/interested/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.name,
                    phone: formData.phone,
                    email: formData.email,
                    course_id: 13,
                    status: 'enrolled' // <--- Cambia a enrolled para sacarlo de remarketing
                })
            }).catch(err => console.error("Error actualizando interesado:", err));

            alert("¡Inscripción registrada con éxito! Hemos enviado los detalles a tu correo.");
            setIsModalOpen(false);
            setModalStep(1);

        } catch (error) {
            console.error(error);
            alert(`Hubo un problema al procesar tu inscripción: ${error.message}`);
        }
    };

    return (
        <div id="import-course-lp" className="bg-[#0b0f19] text-gray-100 font-sans antialiased selection:bg-blue-600 selection:text-white">

            {/* BARRA SUPERIOR DE ESCASEZ / URGENCIA */}
            <div className="bg-gradient-to-r from-blue-700 via-indigo-600 to-blue-800 text-white text-xs sm:text-sm font-bold py-2.5 px-4 text-center tracking-wide shadow-lg relative z-50">
                🚨 CUPOS LIMITADOS: SOLO <span className="underline decoration-amber-400 decoration-2 font-black">{workshopConfig.totalSlots} PARTICIPANTES</span>
            </div>

            {/* NAVBAR / HEADER */}
            <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#07090e]/90 border-b border-gray-800/60">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">


                    {/* Menú de navegación con letras blancas y alta legibilidad */}
                    <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-white">
                        <a href="#metodologia" className="hover:text-blue-400 transition text-white">Metodología</a>
                        <a href="#temario" className="hover:text-blue-400 transition text-white">Temario</a>
                        <a href="#bono" className="hover:text-amber-400 transition flex items-center gap-1.5 text-white">
                            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span> Bono Exclusivo
                        </a>
                        <a href="#pricing-section" className="hover:text-blue-400 transition text-white">Inversión</a>
                    </div>

                    <div>
                        <button
                            onClick={handleInitiateCheckout}
                            className="hidden sm:inline-flex items-center justify-center bg-blue-600 hover:bg-blue-500 text-white text-sm font-bold px-6 py-3 rounded-xl shadow-lg shadow-blue-600/40 transition-all duration-300 transform hover:-translate-y-0.5 border border-blue-400/20"
                        >
                            Reservar Mi Cupo
                        </button>
                    </div>
                </div>
            </header>

            {/* HERO SECTION REDISEÑADO CON ALTO IMPACTO VISUAL */}
            <section className="relative pt-6 sm:pt-12 pb-24 overflow-hidden bg-[#07090e] text-white">
                {/* Efectos de luces de fondo (Glows dinámicos) */}
                <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[350px] bg-blue-600/15 blur-[140px] rounded-full pointer-events-none" />
                <div className="absolute top-1/3 right-10 w-[300px] h-[300px] bg-indigo-600/10 blur-[120px] rounded-full pointer-events-none" />

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

                        {/* Columna Izquierda: Textos y CTA */}
                        <div className="lg:col-span-7 flex flex-col items-center text-center">

                            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-blue-950/80 border border-blue-500/30 text-blue-400 text-xs sm:text-sm font-semibold mb-4 sm:mb-6 shadow-inner">
                                <span className="w-2 h-2 rounded-full bg-blue-400 animate-ping"></span>
                                TALLER PRESENCIAL | MEDELLÍN • SÁBADO 5 DE DICIEMBRE DE 2026
                            </div>

                            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.1] mb-4 sm:mb-6">
                                Aprende a mostrar tus productos o servicios frente a las personas que podrían comprarlos, utilizando la publicidad de Facebook e Instagram
                            </h1>

                            <p className="text-base sm:text-xl text-gray-300 mb-6 sm:mb-8 font-normal leading-relaxed max-w-2xl">
                                Un entrenamiento presencial y práctico en Medellín. Aprende desde cero o lleva tus conocimientos al siguiente nivel.
                            </p>

                            {/* Botón principal alineado correctamente */}
                            <div className="w-full flex justify-center mb-6">
                                <button
                                    onClick={handleInitiateCheckout}
                                    className="w-full sm:w-auto bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-extrabold text-base sm:text-lg px-8 py-4 rounded-2xl shadow-2xl shadow-blue-600/40 transition-all duration-300 transform hover:scale-105 border border-blue-400/30 text-center"
                                >
                                    🚀 QUIERO RESERVAR MI CUPO
                                </button>
                            </div>

                            {/* Aviso inferior protegido */}
                            <div className="inline-flex items-center gap-2 text-amber-400 font-bold uppercase tracking-wider text-xs sm:text-sm bg-amber-500/10 border border-amber-500/20 py-2.5 px-5 rounded-xl shadow-sm">
                                <span>⚠️</span> <span className="text-amber-300">No vienes solamente a escuchar. Vienes a aprender haciendo.</span>
                            </div>
                        </div>

                        {/* Columna Derecha: Tarjeta Visual / Mockup Dinámico de Alto Impacto */}
                        <div className="lg:col-span-5">
                            <div className="relative mx-auto max-w-md lg:max-w-none">
                                <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl blur-xl opacity-30 animate-pulse"></div>
                                <div className="relative bg-gradient-to-b from-gray-900 to-[#0b0f19] border border-gray-800 rounded-3xl p-6 sm:p-8 shadow-2xl space-y-6 text-white">

                                    <div className="flex items-center justify-between border-b border-gray-800 pb-4">
                                        <div className="flex items-center gap-2">
                                            <div className="w-3 h-3 rounded-full bg-red-500"></div>
                                            <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                                            <div className="w-3 h-3 rounded-full bg-green-500"></div>
                                        </div>
                                        <span className="text-xs font-mono text-gray-400">Meta Ads Manager • En Vivo</span>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="bg-blue-950/40 border border-blue-800/40 rounded-2xl p-4">
                                            <div className="text-xs font-semibold text-blue-400 mb-1">📍 Ubicación del Evento</div>
                                            <div className="text-sm font-bold text-white">Belen Malibú, Medellín, Colombia</div>
                                            <div className="text-xs text-gray-400 mt-1">Cupos máximos: 20 personas</div>
                                        </div>

                                        <div className="bg-gray-950/80 border border-gray-800/80 rounded-2xl p-4 flex items-center justify-between">
                                            <div>
                                                <div className="text-xs text-gray-400">Inversión Preventa 1</div>
                                                <div className="text-xl font-black text-white">{workshopConfig.currentPhase.formattedPrice}</div>
                                            </div>
                                            <span className="bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-bold px-3 py-1.5 rounded-xl">
                                                Disponibles
                                            </span>
                                        </div>

                                        {/* Texto del bono forzado a blanco/amarillo */}
                                        <div className="p-3 bg-amber-500/10 border border-amber-500/20 rounded-xl text-center">
                                            <span className="text-xs font-bold text-amber-300">🔥 Incluye Bono Sistema (Sólo 3 inscritos)</span>
                                        </div>
                                    </div>

                                    {/* Botón interior de la tarjeta con texto blanco garantizado */}
                                    <button
                                        onClick={handleInitiateCheckout}
                                        className="w-full py-3.5 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-xl shadow-lg shadow-blue-600/30 transition text-sm tracking-wide"
                                    >
                                        Asegurar mi lugar ahora
                                    </button>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>

            {/* VSL (VIDEO SALES LETTER) */}
            <section className="py-12 bg-[#0f1523] border-t border-gray-800/50 text-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-6">
                        <span className="text-xs font-bold uppercase tracking-widest text-blue-400 bg-blue-950/60 px-3.5 py-1.5 rounded-full border border-blue-900/50">
                            DETENTE UN MOMENTO Y MIRA ESTE VIDEO PRIMERO
                        </span>
                    </div>
                    <div className="relative rounded-3xl overflow-hidden border border-gray-800 bg-gray-900 shadow-2xl aspect-video flex items-center justify-center group">
                        <div className="absolute inset-0 bg-gradient-to-tr from-blue-950/90 via-gray-900 to-indigo-950/70 opacity-90 group-hover:scale-105 transition duration-700"></div>
                        <div className="relative z-20 text-center p-6">
                            <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto shadow-xl shadow-blue-600/50 cursor-pointer hover:bg-blue-500 transition transform hover:scale-110">
                                <svg className="w-8 h-8 fill-current translate-x-0.5" viewBox="0 0 24 24">
                                    <path d="M8 5v14l11-7z" />
                                </svg>
                            </div>
                            <p className="mt-4 text-sm font-bold text-white tracking-wide">Conoce los detalles del taller en este video (90 seg)</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* BONO ESPECIAL SECCIÓN DESTACADA */}
            <section id="bono" className="py-12 bg-[#090c14] border-y border-gray-800/80 relative">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-gradient-to-br from-blue-900/40 via-indigo-950/60 to-gray-900 border-2 border-amber-500/40 rounded-3xl p-6 sm:p-10 shadow-2xl relative overflow-hidden">
                        <div className="absolute -top-10 -right-10 w-40 h-40 bg-amber-500/10 rounded-full blur-3xl pointer-events-none"></div>

                        <div className="flex flex-col lg:flex-row items-center gap-8">
                            <div className="flex-1">
                                <span className="bg-amber-500 text-gray-950 font-black text-xs px-3 py-1 rounded-full uppercase tracking-widest inline-block mb-4 shadow-sm">
                                    🔥 Bono Exclusivo Limitado
                                </span>
                                <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-4">
                                    ¡SI TE INSCRIBES HOY, TE LLEVAS UN BONO GRATIS!
                                </h2>
                                <p className="text-gray-300 text-base sm:text-lg mb-4 leading-relaxed">
                                    Los próximos <span className="text-amber-400 font-bold">3 inscritos</span> que compren hoy recibirán <span className="font-semibold text-white">15 días de acceso GRATIS</span> a <strong className="text-white">¿Qué le Respondo?</strong>, nuestro sistema de inteligencia artificial diseñado para ayudarte a cerrar más ventas por WhatsApp.
                                </p>
                                <p className="text-gray-400 text-sm mb-6 bg-black/30 p-4 rounded-xl border border-gray-800">
                                    <strong className="text-gray-200">¿Qué le Respondo?</strong> es un asistente de ventas con inteligencia artificial que te ayuda a responder mejor a tus clientes, manejar objeciones como "está muy caro" o "lo voy a pensar" y encontrar la respuesta y el siguiente paso más adecuados para avanzar hacia el cierre de una venta.
                                </p>
                                <div className="flex flex-wrap items-center gap-4 text-xs font-semibold text-gray-300">
                                    <span className="bg-blue-950 border border-blue-800/50 px-3 py-1.5 rounded-lg">✓ 15 Días de Acceso Gratis</span>
                                    <span className="bg-blue-950 border border-blue-800/50 px-3 py-1.5 rounded-lg">✓ Valor de referencia: {workshopConfig.bonus.value}</span>
                                    <span className="bg-blue-950 border border-blue-800/50 px-3 py-1.5 rounded-lg">✓ Sin cobros automáticos sin consentimiento</span>
                                </div>
                            </div>

                            {/* Mockup SaaS */}
                            <div className="w-full lg:w-96 bg-gray-950 border border-gray-800 rounded-2xl p-4 shadow-xl">
                                <div className="flex items-center gap-2 mb-3 border-b border-gray-800 pb-2">
                                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                                    <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                                    <span className="text-xs text-gray-500 ml-2 font-mono">quelerespondo.dissempacademy.com</span>
                                </div>
                                <div className="space-y-3 font-sans text-xs">
                                    <div className="bg-blue-950/60 border border-blue-800/40 p-3 rounded-xl">
                                        <p className="text-blue-300 font-semibold mb-1">🤖 Sugerencia del Sistema:</p>
                                        <p className="text-gray-300">"Entiendo que el precio te parezca elevado, Juan. Nuestro servicio incluye garantía y soporte premium..."</p>
                                    </div>
                                    <div className="text-center py-2 text-gray-400 text-[11px]">
                                        Sistema inteligente optimizado para WhatsApp Business
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECCIÓN 2: PROBLEMA */}
            <section className="py-20 bg-[#0f1523]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            ¿TE IDENTIFICAS CON ALGUNA DE ESTAS SITUACIONES?
                        </h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            "Publicas constantemente en redes sociales, pero no consigues suficientes clientes.",
                            "Quieres hacer publicidad, pero no sabes cómo configurar correctamente una campaña.",
                            "Has invertido dinero en anuncios sin entender qué resultados estás obteniendo.",
                            "No sabes cómo segmentar para llegar a personas interesadas en tus productos o servicios.",
                            "Dependes exclusivamente de recomendaciones o publicaciones orgánicas para conseguir clientes.",
                            "Te gustaría dominar Meta Ads, pero sientes que es demasiado complicado."
                        ].map((problem, index) => (
                            <div key={index} className="bg-gray-900/60 border border-gray-800/80 rounded-2xl p-6 hover:border-blue-600/50 transition duration-300 flex flex-col justify-between shadow-lg">
                                <div className="flex items-center gap-3 mb-4">
                                    <span className="w-8 h-8 rounded-full bg-red-500/10 text-red-400 flex items-center justify-center font-bold text-sm">
                                        ✕
                                    </span>
                                    <span className="text-xs font-mono text-gray-500">PROBLEMA 0{index + 1}</span>
                                </div>
                                <p className="text-gray-300 text-base font-medium leading-snug">
                                    "{problem}"
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 text-center bg-blue-950/30 border border-blue-900/50 rounded-2xl p-6 max-w-3xl mx-auto">
                        <p className="text-lg font-medium text-blue-200">
                            Tu negocio no necesita simplemente más publicaciones. Necesita una estrategia para llegar a clientes potenciales y convertir esa atención en oportunidades comerciales.
                        </p>
                    </div>
                </div>
            </section>

            {/* SECCIÓN 3: SOLUCIÓN Y METODOLOGÍA */}
            <section id="metodologia" className="py-20 bg-gradient-to-b from-[#0b0f19] to-[#0f1523] border-t border-gray-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <span className="text-blue-400 font-bold tracking-widest text-xs uppercase bg-blue-950/80 px-3 py-1 rounded-full border border-blue-800/40 inline-block mb-4">
                                METODOLOGÍA PRÁCTICA
                            </span>
                            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-6">
                                EN 5 HORAS VAS A PASAR DE NO SABER POR DÓNDE EMPEZAR A TENER TU PROPIA CAMPAÑA ESTRUCTURADA.
                            </h2>
                            <p className="text-gray-300 text-base leading-relaxed mb-6">
                                Este no es un seminario aburrido de diapositivas estáticas. Cada asistente trabajará directamente en su propio computador portátil, guiado paso a paso por el instructor para estructurar anuncios reales.
                            </p>
                            <ul className="space-y-3 text-gray-300 font-medium">
                                <li className="flex items-center gap-3">
                                    <span className="text-blue-500 font-bold">✓</span> Formación paso a paso adaptada a principiantes.
                                </li>
                                <li className="flex items-center gap-3">
                                    <span className="text-blue-500 font-bold">✓</span> Ejemplos prácticos y ejercicios en tiempo real.
                                </li>
                                <li className="flex items-center gap-3">
                                    <span className="text-blue-500 font-bold">✓</span> Acompañamiento directo del instructor.
                                </li>
                            </ul>
                        </div>

                        <div className="bg-gray-900 border border-gray-800 p-3 rounded-2xl shadow-2xl relative">
                            <div className="bg-blue-950/40 rounded-xl overflow-hidden border border-gray-800 p-8 text-center">
                                <div className="text-5xl font-black text-blue-500 mb-2">5 HORAS</div>
                                <div className="text-xl font-bold text-white mb-4">De Práctica Intensiva Presencial</div>
                                <p className="text-sm text-gray-400">Sábado 5 de diciembre de 2026 • Saudé Medical Coworking, Medellín, Colombia</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECCIÓN 4: TEMARIO */}
            <section id="temario" className="py-20 bg-[#0f1523]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-blue-400 font-bold tracking-widest text-xs uppercase bg-blue-950/80 px-3 py-1 rounded-full border border-blue-800/40 inline-block mb-4">
                            CONTENIDO DETALLADO
                        </span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            ¿QUÉ VAS A APRENDER DURANTE EL TALLER?
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            { title: "1. La publicidad digital HOY", items: ["Cómo ha evolucionado la publicidad en Facebook e Instagram.", "Cómo aprovechar la publicidad digital para conseguir clientes.", "Diferencias entre publicidad orgánica y pagada."] },
                            { title: "2. Configuración de Activos", items: ["Administrador de anuncios.", "Página de Facebook, whatsApp, cuenta publicitaria e Instagram."] },
                            { title: "3. Identifica a tu cliente potencial", items: ["Cómo definir a tu cliente ideal.", "Identifica sus necesidades, problemas y deseos.", "Cómo encontrar y segmentar a tus potenciales compradores."] },
                            { title: "4. Creativos que sí venden de verdad", items: ["Qué imágenes y videos captan la atención.", "Cómo crear anuncios con herramientas de inteligencia artificial.", "Errores creativos que pueden hacerte perder dinero."] },
                            { title: "5. Copywriting de alta conversión", items: ["Cómo escribir textos publicitarios persuasivos.", "Hooks que captan la atención y detienen el scroll.", "Llamados a la acción que motivan a tus clientes."] },
                            { title: "6. Creación de Campañas", items: ["Objetivos publicitarios y estructura de campañas.", "Configuración de conjuntos de anuncios y anuncios.", "Presupuestos y distribución de la inversión."] },
                            { title: "7. Medición y algunos números", items: ["Métricas que realmente debes conocer.", "Cómo interpretar los resultados de tus campañas.", "Costo por Resultado", "Cómo identificar anuncios ganadores y optimizar resultados."] },
                            { title: "8. Práctica Final", items: ["Construcción y configuración de una campaña para tu negocio o producto.", "Aplicación práctica de lo aprendido.", "Orientación y revisión personalizada del instructor."] }
                        ].map((mod, idx) => (
                            <div key={idx} className="bg-gray-900 border border-gray-800 rounded-2xl p-6 shadow-xl hover:border-blue-500/50 transition">
                                <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                                    {mod.title}
                                </h3>
                                <ul className="space-y-2 text-sm text-gray-300">
                                    {mod.items.map((item, i) => (
                                        <li key={i} className="flex items-start gap-2">
                                            <span className="text-blue-400 text-xs mt-0.5">▪</span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECCIÓN DE 2 BONOS EXCLUSIVOS (PDFs) */}
            <section id="bonos" className="py-20 bg-[#07090e] border-t border-gray-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-amber-400 font-bold tracking-widest text-xs uppercase bg-amber-500/10 px-4 py-1.5 rounded-full border border-amber-500/30 inline-block mb-4 shadow-sm">
                            🎁 REGALOS DE ACCIÓN RÁPIDA
                        </span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            LLÉVATE 2 BONOS TOTALMENTE GRATIS AL INSCRIBIRTE HOY
                        </h2>
                        <p className="text-gray-300 text-base">Material exclusivo descargable para acelerar tus resultados desde el primer día.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                        {/* Bono 1 */}
                        <div className="bg-gradient-to-b from-gray-900 to-[#0b0f19] border border-blue-500/30 rounded-3xl p-8 shadow-xl flex flex-col justify-between relative overflow-hidden">
                            <div className="absolute top-0 right-0 bg-blue-600 text-white text-[10px] font-black uppercase px-4 py-1 rounded-bl-xl">
                                Valorado en $37.000 COP
                            </div>
                            <div>
                                <div className="w-12 h-12 rounded-2xl bg-blue-600/20 border border-blue-500/40 text-blue-400 flex items-center justify-center font-black text-xl mb-6">
                                    📄
                                </div>
                                <h3 className="text-xl font-black text-white mb-3">Bono 1: Guía de los Errores Más Comunes en tu cierre de ventas</h3>
                                <p className="text-gray-300 text-sm leading-relaxed mb-6">
                                    Una guía en formato PDF que te enseña los errores más comunes al responder a clientes por whatsApp
                                </p>
                            </div>
                            <div className="border-t border-gray-800 pt-4 flex items-center justify-between text-xs text-gray-400 font-mono">
                                <span>Formato: Guía Digital PDF</span>
                                <span className="text-blue-400 font-bold">100% Gratis con tu entrada en 1ra y 2da preventa</span>
                            </div>
                        </div>

                        {/* Bono 2 */}
                        <div className="bg-gradient-to-b from-gray-900 to-[#0b0f19] border border-blue-500/30 rounded-3xl p-8 shadow-xl flex flex-col justify-between relative overflow-hidden">
                            <div className="absolute top-0 right-0 bg-blue-600 text-white text-[10px] font-black uppercase px-4 py-1 rounded-bl-xl">
                                Valorado en $49.000 COP
                            </div>
                            <div>
                                <div className="w-12 h-12 rounded-2xl bg-blue-600/20 border border-blue-500/40 text-blue-400 flex items-center justify-center font-black text-xl mb-6">
                                    📊
                                </div>
                                <h3 className="text-xl font-black text-white mb-3">Bono 2: Guia express para Cerrar mas ventas por whatsapp</h3>
                                <p className="text-gray-300 text-sm leading-relaxed mb-6">
                                    Guía express que te enseña algunas estrategias para que cierres más ventas por whatsApp
                                </p>
                            </div>
                            <div className="border-t border-gray-800 pt-4 flex items-center justify-between text-xs text-gray-400 font-mono">
                                <span>Formato: Guía Digital PDF</span>
                                <span className="text-blue-400 font-bold">100% Gratis con tu entrada en 1ra y 2da preventa</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECCIÓN DEL INSTRUCTOR */}
            <section className="py-20 bg-[#0f1523] border-t border-gray-800">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <span className="text-blue-400 font-bold tracking-widest text-xs uppercase bg-blue-950/80 px-4 py-1.5 rounded-full border border-blue-800/40 inline-block mb-4 shadow-sm">
                            EXPERTICIA Y GUÍA
                        </span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            APRENDE DIRECTAMENTE CON QUIEN TE GUÍA PASO A PASO
                        </h2>
                    </div>

                    <div className="bg-gradient-to-b from-gray-900 to-[#0b0f19] border border-gray-800 rounded-3xl p-8 sm:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-8">
                        {/* Fotografía o avatar placeholder del instructor */}
                        <div className="w-36 h-36 sm:w-44 sm:h-44 rounded-2xl bg-gray-800 border-2 border-blue-600/50 flex-shrink-0 overflow-hidden shadow-inner relative group">
                            <img
                                src={workshopConfig.instructor.photoUrl}
                                alt={workshopConfig.instructor.name}
                                className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                            />
                        </div>

                        <div className="text-center md:text-left">
                            <h3 className="text-2xl font-black text-white mb-2">{workshopConfig.instructor.name}</h3>
                            <p className="text-blue-400 text-xs font-semibold uppercase tracking-wider mb-4">Instructor Oficial • Dissemp Academy</p>
                            <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                                {workshopConfig.instructor.bio}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECCIÓN 5: PRECIOS */}
            <section id="pricing-section" className="py-20 bg-[#07090e] border-t border-gray-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-blue-400 font-bold tracking-widest text-xs uppercase bg-blue-950/80 px-4 py-1.5 rounded-full border border-blue-800/40 inline-block mb-4 shadow-sm">
                            INSCRIPCIONES ABIERTAS
                        </span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            ASEGURA TU CUPO EN EL TALLER
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto items-center">
                        {workshopConfig.stages.map((stage, idx) => (
                            <div
                                key={idx}
                                className={`rounded-3xl p-8 flex flex-col justify-between relative transition-all duration-300 ${stage.active
                                    ? 'bg-blue-950/40 border-2 border-blue-500 shadow-[0_0_30px_rgba(59,130,246,0.3)] z-10'
                                    : 'bg-gray-900/40 border border-gray-800/80 opacity-75 hover:opacity-90'
                                    }`}
                            >
                                {stage.active && (
                                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-black uppercase tracking-wider px-5 py-1.5 rounded-full shadow-lg border border-blue-400">
                                        Preventa Activa
                                    </div>
                                )}

                                <div>
                                    <h3 className={`text-xl font-black mb-2 ${stage.active ? 'text-blue-400' : 'text-white'}`}>
                                        {stage.name}
                                    </h3>
                                    <p className="text-xs text-gray-400 mb-6 font-mono">{stage.slots}</p>
                                    <div className="text-3xl font-extrabold text-white mb-6">
                                        {stage.price}
                                    </div>

                                    <ul className="space-y-3 text-sm text-gray-300 mb-8 border-t border-gray-800/60 pt-6">
                                        <li className="flex items-center gap-2">✓ 5 horas presenciales</li>
                                        <li className="flex items-center gap-2">✓ Estrategias prácticas</li>
                                        <li className="flex items-center gap-2">✓ Acompañamiento del instructor</li>
                                    </ul>
                                </div>

                                <button
                                    onClick={() => setIsModalOpen(true)}
                                    className={`w-full py-4 rounded-xl font-bold text-sm tracking-wider uppercase transition-all shadow-lg ${stage.active
                                        ? 'bg-blue-600 hover:bg-blue-500 text-white shadow-blue-600/40'
                                        : 'bg-gray-800/80 text-gray-400 cursor-not-allowed border border-gray-700/50'
                                        }`}
                                    disabled={!stage.active}
                                >
                                    {stage.active ? "QUIERO ASEGURAR MI CUPO" : "Abre pronto"}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECCIÓN 9: PREGUNTAS FRECUENTES */}
            <section id="faq" className="py-20 from-[#0b0f19] to-[#0f1523]">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-4">
                            PREGUNTAS FRECUENTES
                        </h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
                    </div>

                    <div className="space-y-4">
                        {[
                            { q: "¿Necesito tener conocimientos previos de Meta Ads?", a: "No. El taller está diseñado para principiantes y nivel intermedio." },
                            { q: "¿Debo llevar mi computador?", a: "Sí. Cada participante debe llevar su propio portátil." },
                            { q: "¿Dónde se realizará?", a: "En Medellín. La dirección es Calle 31A 65F-110, Belen Malibú." },
                            { q: "¿Cuánto dura el taller?", a: "Cinco horas, de 1:00 p. m. a 6:00 p. m el día sábado 5 de diciembre." },
                            { q: "¿Es un curso teórico?", a: "No, esta formación es 100% práctica y saldrás con tu primera campaña creada." }
                        ].map((faq, index) => (
                            <div key={index} className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden shadow-md">
                                <button
                                    onClick={() => toggleFaq(index)}
                                    className="w-full p-6 text-left font-semibold text-white flex justify-between items-center gap-4 hover:bg-gray-800/50 transition text-black"
                                >
                                    <span>{faq.q}</span>
                                    <span className="text-blue-500 font-bold text-xl">{openFaq === index ? "−" : "+"}</span>
                                </button>
                                {openFaq === index && (
                                    <div className="px-6 pb-6 text-gray-300 text-sm leading-relaxed border-t border-gray-800 pt-4">
                                        {faq.a}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-16 bg-gradient-to-t from-gray-900 to-[#0b0f19] border-t border-gray-800 text-center">
                <div className="max-w-3xl mx-auto px-4">
                    <h3 className="text-2xl sm:text-3xl font-black text-white mb-4">¿Tienes alguna duda antes de inscribirte?</h3>
                    <p className="text-gray-300 text-sm sm:text-base mb-8">Escríbenos directamente a nuestro WhatsApp oficial y te responderemos de inmediato.</p>
                    <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white font-extrabold text-base px-8 py-4 rounded-2xl shadow-xl shadow-emerald-600/30 transition transform hover:scale-105"
                    >
                        💬 Hablar con un asesor por WhatsApp
                    </a>
                </div>
            </section>

            {/* FOOTER */}
            <footer className="bg-[#05080f] py-12 border-t border-gray-900 text-center text-xs text-gray-500">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
                    <p className="font-bold text-gray-400">DISSEMP ACADEMY • Todos los derechos reservados</p>
                    <p>Medellín, Colombia • Formación y capacitación en marketing digital y tecnología.</p>
                </div>
            </footer>

            {/* BOTÓN FLOTANTE DE WHATSAPP (Aparece estático al hacer scroll) */}
            {showWhatsAppFloat && (
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fixed bottom-6 right-6 z-50 bg-emerald-500 hover:bg-emerald-400 text-white w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center shadow-2xl shadow-emerald-500/50 transition-all duration-300 transform hover:scale-105"
                    title="¿Tienes dudas? Escríbenos por WhatsApp"
                >
                    <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                    </svg>
                </a>
            )}

            {/* MODAL DE INSCRIPCIÓN */}
            {/* MODAL DE INSCRIPCIÓN Y PAGOS MEJORADO */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto">
                    <div className="bg-[#0b0f19] border border-blue-500/40 rounded-3xl p-6 sm:p-8 max-w-lg w-full shadow-2xl relative text-white my-8">

                        {/* Botón de cerrar */}
                        <button
                            onClick={() => { setIsModalOpen(false); setModalStep(1); }}
                            className="absolute top-4 right-4 text-gray-400 hover:text-white text-xl font-bold w-8 h-8 rounded-full bg-gray-800/80 flex items-center justify-center"
                        >
                            ✕
                        </button>

                        {modalStep === 1 ? (
                            /* ================= PASO 1: DATOS DE CONTACTO ================= */
                            <div>
                                <div className="text-center mb-6">
                                    <span className="text-blue-400 font-bold text-xs uppercase bg-blue-950/80 px-3 py-1 rounded-full border border-blue-500/30">
                                        Paso 1 de 2
                                    </span>
                                    <h3 className="text-2xl font-black mt-3">Completa tus datos</h3>
                                    <p className="text-gray-300 text-sm mt-1">Para asegurar tu cupo en la Preventa 1 del taller presencial.</p>
                                </div>

                                <form onSubmit={handleFormSubmit} className="space-y-4">
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-300 mb-1">Nombre completo</label>
                                        <input
                                            type="text"
                                            required
                                            placeholder="Ej. Carlos Pérez"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            className="w-full bg-gray-900 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 transition"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-semibold text-gray-300 mb-1">Número de WhatsApp (Celular)</label>
                                        <input
                                            type="tel"
                                            required
                                            placeholder="Ej. 3001234567"
                                            value={formData.phone}
                                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                            className="w-full bg-gray-900 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 transition"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-semibold text-gray-300 mb-1">Correo electrónico</label>
                                        <input
                                            type="email"
                                            required
                                            placeholder="correo@ejemplo.com"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            className="w-full bg-gray-900 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 transition"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white font-extrabold rounded-xl shadow-lg shadow-blue-600/40 transition text-sm tracking-wide mt-2"
                                    >
                                        Continuar al pago seguro ➔
                                    </button>
                                </form>

                                <p className="text-[11px] text-gray-500 text-center mt-4">
                                    🔒 Tus datos están seguros y no serán compartidos.
                                </p>
                            </div>
                        ) : (
                            /* ================= PASO 2: MÉTODOS DE PAGO ================= */
                            <div>
                                <div className="text-center mb-6">
                                    <span className="text-blue-400 font-bold text-xs uppercase bg-blue-950/80 px-3 py-1 rounded-full border border-blue-500/30">
                                        Paso 2 de 2
                                    </span>
                                    <h3 className="text-xl font-black mt-3">2. Método de pago seguro</h3>
                                </div>

                                {/* Botones de selección de método de pago estilo pastilla */}
                                <div className="bg-blue-950/30 border border-blue-900/40 p-2 rounded-2xl grid grid-cols-2 gap-2 mb-6">
                                    <button
                                        type="button"
                                        onClick={() => setPaymentMethod('transfer')}
                                        className={`py-3 px-4 rounded-xl font-bold text-xs sm:text-sm transition ${paymentMethod === 'transfer'
                                            ? 'bg-blue-600 text-white shadow-lg'
                                            : 'bg-transparent text-gray-400 hover:text-white'
                                            }`}
                                    >
                                        Transferencia
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setPaymentMethod('card')}
                                        className={`py-3 px-4 rounded-xl font-bold text-xs sm:text-sm transition ${paymentMethod === 'card'
                                            ? 'bg-blue-600 text-white shadow-lg'
                                            : 'bg-transparent text-gray-400 hover:text-white'
                                            }`}
                                    >
                                        Tarjeta / PSE
                                    </button>
                                </div>

                                {paymentMethod === 'transfer' ? (
                                    /* VISTA TRANSFERENCIA */
                                    <div className="space-y-4 bg-gray-900/60 border border-gray-800 p-5 rounded-2xl">
                                        <div className="text-center bg-amber-500/10 border border-amber-500/20 p-3 rounded-xl">
                                            <span className="text-xs text-amber-300 font-semibold">⏱ Proceso rápido: sube tu comprobante y recibe acceso en máximo 24 horas</span>
                                        </div>

                                        <div className="text-center bg-gray-950 p-4 rounded-xl border border-gray-800">
                                            <span className="text-xs text-gray-400 block mb-1">TOTAL A TRANSFERIR:</span>
                                            <span className="text-2xl font-black text-amber-400">{workshopConfig.currentPhase.formattedPrice}</span>
                                        </div>

                                        {/* Cuenta Bancolombia */}
                                        <div className="bg-gray-950 p-3.5 rounded-xl border border-gray-800 flex items-center justify-between">
                                            <div>
                                                <span className="text-[10px] text-gray-400 uppercase font-mono block">BANCOLOMBIA AHORROS</span>
                                                <span className="text-sm font-bold text-white font-mono">00689258018</span>
                                            </div>
                                            <button
                                                onClick={() => copyToClipboard("00689258018")}
                                                className="text-xs bg-gray-800 hover:bg-gray-700 px-3 py-1.5 rounded-lg text-gray-300 border border-gray-700 transition"
                                            >
                                                {copied ? "¡Copiado!" : "Copiar"}
                                            </button>
                                        </div>

                                        {/* Cuenta Nequi */}
                                        <div className="bg-gray-950 p-3.5 rounded-xl border border-gray-800 flex items-center justify-between">
                                            <div>
                                                <span className="text-[10px] text-gray-400 uppercase font-mono block">NEQUI</span>
                                                <span className="text-sm font-bold text-white font-mono">3177169274</span>
                                            </div>
                                            <button
                                                onClick={() => copyToClipboard("3177169274")}
                                                className="text-xs bg-gray-800 hover:bg-gray-700 px-3 py-1.5 rounded-lg text-gray-300 border border-gray-700 transition"
                                            >
                                                Copiar
                                            </button>
                                        </div>

                                        {/* Subir comprobante */}
                                

                                        <div>
                                            <label className="block text-xs font-semibold text-gray-300 mb-2">SUBIR COMPROBANTE DE PAGO</label>
                                            <label className="border-2 border-dashed border-gray-700 hover:border-blue-500 rounded-xl p-4 flex flex-col items-center justify-center cursor-pointer bg-gray-950 transition">
                                                <span className="text-xs text-gray-400 text-center">☁️ Clic para subir imagen (JPG/PNG)</span>
                                                <input type="file" accept="image/*" className="hidden" />
                                            </label>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={handleTransferSubmit}
                                            className="w-full py-4 bg-lime-400 hover:bg-lime-300 text-gray-950 font-extrabold rounded-xl shadow-lg transition text-sm tracking-wide mt-2"
                                        >
                                            Completar mi inscripción ➔
                                        </button>
                                    </div>
                                ) : (
                                    /* VISTA TARJETA / PSE */
                                    <div className="space-y-4 bg-gray-900/60 border border-gray-800 p-5 rounded-2xl">
                                        <div className="text-xs font-bold text-blue-400 mb-1">Datos del Titular de la Tarjeta</div>

                                        <div>
                                            <label className="block text-[11px] font-semibold text-gray-400 uppercase mb-1">NOMBRE DEL PAGADOR</label>
                                            <input
                                                type="text"
                                                placeholder="Como aparece en la tarjeta"
                                                className="w-full bg-gray-950 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 transition"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-[11px] font-semibold text-gray-400 uppercase mb-1">CORREO DEL PAGADOR</label>
                                            <input
                                                type="email"
                                                defaultValue={formData.email}
                                                className="w-full bg-gray-950 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500 transition"
                                            />
                                        </div>

                                        <p className="text-[11px] text-gray-400 text-center py-2">
                                            Con este curso aprenderás publicidad de forma práctica sí o sí.
                                        </p>

                                        <button
                                            onClick={() => alert("Redirigiendo a pasarela de pago segura con Tarjeta/PSE...")}
                                            className="w-full py-4 bg-blue-500 hover:bg-blue-400 text-white font-extrabold rounded-xl shadow-lg transition text-sm tracking-wide"
                                        >
                                            PAGAR AHORA
                                        </button>
                                    </div>
                                )}

                                <div className="flex items-center justify-center gap-6 text-[11px] text-gray-400 mt-6 border-t border-gray-800/80 pt-4">
                                    <span>🔒 Pago 100% seguro</span>
                                    <span>🛡️ Garantía incluida</span>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            )}

        </div>
    );
}